import _ from 'lodash/fp'
import gql from 'graphql-tag'
import { all, call, put, takeLatest } from 'redux-saga/effects'

import { types, actions } from '../reducers/roles'
import { apolloClient } from '@fe/business/src/apollo'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

const SELECTABLE_ROLES_QUERY = gql`
  query SelectableRoles {
    selectableRoles
  }
`

export function * loadEffect () {
  try {
    const response = yield call([apolloClient, apolloClient.query], {
      query: SELECTABLE_ROLES_QUERY,
      fetchPolicy: 'network-only'
    })
    return _.getOr([], 'data.selectableRoles', response)
  } catch (error) {
    return { error }
  }
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

export function * loadFlow () {
  const result = yield call(loadEffect)

  if (result.error) {
    yield put(actions.loadError(result))
  } else {
    yield put(actions.loadSuccess(result))
  }

  yield put(actions.loadRequestDone())
}

export default function * () {
  return yield all([
    takeLatest(types.LOAD_REQUEST, loadFlow)
  ])
}
